import { Formik } from 'formik'

// Components

// Libs
import getformikConfig from './formikConfig'

export const defaultProps = {}

function PortraitReleaseAgreementPopupContentFormik(props: any) {
  const { children }: any = props

  const formikConfig: any = getformikConfig()

  return <Formik {...formikConfig}>{() => children}</Formik>
}

PortraitReleaseAgreementPopupContentFormik.defaultProps = defaultProps

export default PortraitReleaseAgreementPopupContentFormik
